import { TFactoryIdNameDTO } from './process-mapping-API.types';
import { TFilterSelected } from '../filter.types';
import { TPaginationInfo } from '../input-app/fabric-inspection/api.types';
import { TCustomView } from './ll-board-API.types';

export type TTimelineDateRangeDTO = { from: string; to: string };

export const CAPACITY_BOARD_LOAD_TYPES = [
  'HIGHLY_OVERLOADED',
  'OVERLOADED',
  'UNIFORMLY_LOADED',
  'UNDERLOADED',
  'NO_CAPACITY',
] as const;
export type TCapacityBoardLoadType = (typeof CAPACITY_BOARD_LOAD_TYPES)[number];
export type TProcessBoardsProcessList = { processId: string; processName: string }[];

export type TREQUEST_GET_CAPACITY_BOARD = {
  processId?: string;
  boardViewType: 'WEEKLY' | 'MONTHLY';
  dateRange?: TTimelineDateRangeDTO;
  offset?: 'DEFAULT' | 'PREV' | 'NEXT';
};

export type TCapacityBoardUtilizationData = {
  utilization: number;
  status: TCapacityBoardLoadType;
  dateRange: NonNullable<TREQUEST_GET_CAPACITY_BOARD['dateRange']>;
};

export type TRESPONSE_GET_CAPACITY_BOARD = {
  selectedProcessId: string;
  allProcesses: TProcessBoardsProcessList;
  boardResponseView: {
    boardViewType: TREQUEST_GET_CAPACITY_BOARD['boardViewType'];
    currentDate: string;
    dateRange: TTimelineDateRangeDTO;
  };
  capacityBoardDTO: {
    accountLevelUtilizationData: TCapacityBoardUtilizationData[];
    factoryLevelUtilizationData?: {
      factory: TFactoryIdNameDTO;
      utilizationStrips: TCapacityBoardUtilizationData[];
    }[];
    orderSummaries: {
      today: TCapacityBoardOrderSummary;
      week: TCapacityBoardOrderSummary;
      month: TCapacityBoardOrderSummary;
    };
  };
};

type TCapacityBoardOrderSummary = {
  totalOrders: number;
  runningStyles: number;
  pending: number;
  status: TCapacityBoardLoadType;
};
export type TRESPONSE_GET_CAPACITY_BOARD_STATUS = {
  pollFurther: boolean;
  pollIntervalInSeconds: number;
  message: string;
  status: string;
};

export type TREQUEST_GET_CAPACITY_STRIP_DETAILS = {
  processId: string;
  dateRange: TTimelineDateRangeDTO;
} & ({ viewType: 'ACCOUNT_WISE' } | { viewType: 'FACTORY_WISE'; factoryId: string });

export type TRESPONSE_GET_CAPACITY_STRIP_DETAILS = {
  headerInfo: { key: string; displayName: string }[];
  detailedStripDTO: Partial<Record<string, string>>[];
};

/*** Planning board ***/

const PLANNING_BOARD_CUSTOM_THEME_VIEWS = ['BUYER', 'PRODUCT_TYPE', 'DEFAULT'] as const;

export type TREQUEST_GET_PLANNING_BOARD = {
  processId?: string;
  boardView: {
    boardViewType: 'WEEKLY' | 'MONTHLY';
    customViewMode: (typeof PLANNING_BOARD_CUSTOM_THEME_VIEWS)[number];
    dateRange?: { from: string; to: string };
    offset?: 'DEFAULT' | 'PREV' | 'NEXT';
  };
  selectedFilters: TFilterSelected[];
  pageSize: number;
  pageNumber: number;
};
export type TRESPONSE_GET_PLANNING_BOARD = {
  selectedProcessId: string;
  allProcesses: TProcessBoardsProcessList;
  planningBoardDTO: {
    strips: {
      dateRange: { from: string; to: string };
      oplId: string;
      userOPLId: string;
      installedCapacity: number;
      allocatedCapacity: number;
      stripColor: TCustomView['valueToColorMap'][string];
    }[];
    boardView: {
      boardViewType: TREQUEST_GET_PLANNING_BOARD['boardView']['boardViewType'];
      dateRange: { from: string; to: string };
      currentDate: string;
    };
    customView: {
      viewMode: TREQUEST_GET_PLANNING_BOARD['boardView']['customViewMode'];
      valueToColorMap: Partial<TCustomView['valueToColorMap']>;
    };
  };
  paginationInfo: TPaginationInfo;
  lastRefreshTime: string;
};

export type TREQUEST_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID = {
  oplId: string;
  baseProcessId: string;
};
export type TRESPONSE_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID = {
  oplId: string;
  orderId: string;
  typeOfOrder: string;
  buyer: string;
  style: string;
  po?: string | null;
  erp?: string | null;
  orderQty: number;
  orderDate: string;
  dateWiseQtyDetails: { date: string; plannedQty: string }[];
};

/************** ORDER TIMELINE VIEW **************/
export type TOrderTimelineViewBoardViewType = 'WEEKLY' | 'MONTHLY';

export type TREQUEST_GET_ORDER_TIMELINE_VIEW = {
  boardViewType: TOrderTimelineViewBoardViewType;
  offset: 'DEFAULT' | 'PREV' | 'NEXT';
  dateRange?: TTimelineDateRangeDTO;
  pageSize: number;
  pageNumber: number;
};

export type TRESPONSE_GET_ORDER_TIMELINE_VIEW = {
  dateViewResponse: {
    boardViewType: TOrderTimelineViewBoardViewType;
    dateRange: TTimelineDateRangeDTO;
    currentDate: string;
  };
  orderViewInfo: {
    userOtlId: string;
    factoryProcessBreakdowns: {
      factoryId: string;
      factoryName: string;
      processName: string;
      dayWiseQty: { date: string; qty: number }[];
    }[];
  }[];
  paginationInfo: TPaginationInfo;
};
